export const addingZeroToNumber = (data: number | string) =>
  data.toString().length === 1 ? '0'.concat(data.toString()) : `${data}`;
